import { DashboardLayout } from "components/DashboardLayout";
import { Header } from "components/DesignSystem/Header/Header";
import { Reconcile } from "components/Reconciliation/Reconcile";
import { Reconciliation as ReconciliationPage } from "components/Reconciliation/Reconciliation";
import { ReconciliationHistory } from "components/Reconciliation/ReconciliationHistory/ReconciliationHistory";
import { useConstructInternalLink } from "hooks/useConstructInternalLink";
import { useQuery } from "hooks/useQuery";
import { ReactNode } from "react";
import { Route, Switch, useHistory, useRouteMatch } from "react-router-dom";

const AI_RECONCILE_MODE = "ai";

const ReconciliationLayout = ({ children }: { children?: ReactNode }) => {
  return (
    <>
      <DashboardLayout
        header={
          <Header
            v2
            title={
              <div className="t-flex t-gap-2 t-items-center">
                Reconciliation
              </div>
            }
          />
        }
      >
        <ReconciliationPage />
      </DashboardLayout>
      {children}
    </>
  );
};

const ReconciliationHisotryLayout = ({
  children,
}: {
  children?: ReactNode;
}) => {
  return (
    <>
      <ReconciliationHistory />
      {children}
    </>
  );
};

export const Reconciliation = () => {
  const { path, url } = useRouteMatch();
  const history = useHistory();
  const { link } = useConstructInternalLink();
  const query = useQuery();
  const reconcileMode =
    query.get("mode") === AI_RECONCILE_MODE ? "ai" : "manual";

  return (
    <>
      <Switch>
        <Route exact path={path}>
          <ReconciliationLayout />
        </Route>
        <Route exact path={`${path}/history/:bankAccountId`}>
          <ReconciliationHisotryLayout />
        </Route>
      </Switch>

      <Route path={`${path}/start/:bankAccountId`}>
        {({ match }) => {
          if (!match) {
            return null;
          }

          return (
            <ReconciliationLayout>
              <Reconcile
                isOpen
                onClose={() => history.push(link(path))}
                bankAccountId={match.params.bankAccountId}
                mode={reconcileMode}
              />
            </ReconciliationLayout>
          );
        }}
      </Route>

      <Route
        path={`${path}/history/:historyBankAccountId/start/:bankAccountId`}
      >
        {({ match }) => {
          if (!match) {
            return null;
          }

          return (
            <ReconciliationHisotryLayout>
              <Reconcile
                isOpen
                onClose={() =>
                  history.push(
                    link(`${path}/history/${match.params.historyBankAccountId}`)
                  )
                }
                bankAccountId={match.params.bankAccountId}
                mode={reconcileMode}
              />
            </ReconciliationHisotryLayout>
          );
        }}
      </Route>
    </>
  );
};
